module.exports = __webpack_public_path__ + "img/edge_divers_poussette.597762ab.svg";